module.exports = __webpack_public_path__ + "h5/img/defaultbgd.87777396.png";